// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__29f-A","large":"styles_large__1p0c0"};